<div *ngIf="!cookieMessageHidden" class="cookie-notice">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col">
        <span> {{ 'We use cookies on this website to ensure the best possible service:' | translate }}
          <a (click)="onPrivacyPolicyClick()">{{ 'Privacy Policy' | translate }}</a>
        </span>
      </div>
      <div class="col-1">
        <button type="button" class="close" aria-label="Close" (click)="closeCookie()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  </div>
</div>
